/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { MeasureEntry, createMeasureEntry } from './MeasureEntry';

export type Measure = {
  us: MeasureEntry;
  metric: MeasureEntry;
};

export function createMeasure(json?: Partial<Measure>): Measure {
  return makeAutoObservable({
    us: createMeasureEntry(json?.us),
    metric: createMeasureEntry(json?.metric),
  });
}
